import { hi } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { render } from "react-dom";
import ReactQuill from "react-quill";
const Quill = ReactQuill.Quill;
const fontFamilyArr = [
  "Roboto Condensed",
  "Times New Roman",
  "Calibri",
  "Calibri Light",
  "sans-serif",
  "verdana",
  "helvetica",
];
const fonts = Quill.import("attributors/style/font");
fonts.whitelist = fontFamilyArr;
Quill.register(fonts, true);

const fontSizeArr = ["10px", "11px", "12px", "13px", "18px", "24px"];
const Size = Quill.import("attributors/style/size");
Size.whitelist = fontSizeArr;
Quill.register(Size, true);

const defaultToolbarValues = [
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  [
    {
      color: [
        "#000000",
        "#e60000",
        "#ff9900",
        "#ffff00",
        "#008a00",
        "#0066cc",
        "#9933ff",
        "#ffffff",
        "#facccc",
        "#ffebcc",
        "#ffffcc",
        "#cce8cc",
        "#cce0f5",
        "#ebd6ff",
        "#bbbbbb",
        "#f06666",
        "#ffc266",
        "#ffff66",
        "#66b966",
        "#66a3e0",
        "#c285ff",
        "#888888",
        "#a10000",
        "#b26b00",
        "#b2b200",
        "#006100",
        "#0047b2",
        "#6b24b2",
        "#444444",
        "#5c0000",
        "#663d00",
        "#666600",
        "#003700",
        "#002966",
        "#3d1466",
        "#E6F0E9",
        "#697D7A",
        "#757575",
      ],
    },
  ],
];

export default function Editor(props: any) {
  const {
    enableCustomToolBar,
    customToolbar,
    hideToolbar,
    className,
    readOnly = false,
  } = props;

  const toolbar = enableCustomToolBar ? customToolbar : defaultToolbarValues;

  const modules = {
    toolbar: hideToolbar ? !hideToolbar : toolbar,
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "link",
    "color",
    "image",
    "background",
    "align",
    "size",
    "font",
  ];

  const [code, setCode] = useState("");
  const { updateData, editorData } = props;
  useEffect(() => {
    setCode(editorData);
  }, [editorData]);
  const handleProcedureContentChange = (
    content: any,
    delta: any,
    source: any,
    editor: any
  ) => {
    setCode(content);
    updateData(content);

    //let has_attribues = delta.ops[1].attributes || "";
    //const cursorPosition = e.quill.getSelection().index;
    // this.quill.insertText(cursorPosition, "★");
    //this.quill.setSelection(cursorPosition + 1);
  };

  return (
    <>
      <div className={`${className} react-quil-container hoverOnQuill`}>
        <ReactQuill
          style={{ fontSize: "13px" }} // Apply custom styles
          readOnly={readOnly}
          theme="snow"
          modules={modules}
          formats={formats}
          value={code}
          onChange={handleProcedureContentChange}
        />
      </div>
    </>
  );
}
